import { Group } from "../../../../application/domain/group/group";

type DetailEditProps = {
  groups: Group[];
};

export const SettingGroupList: React.FC<DetailEditProps> = ({ groups }) => {
  return (
    <div className="field">
      <div className="label">管理グループ</div>
      {groups.map((v) => (
        <div key={v.id}>{v.name}</div>
      ))}
    </div>
  );
};
